import React, { Component } from 'react';

//Compponent


import EmailVerify from '../organisms/EmailVerify';

class Verify extends Component {
	render() {
		return (
			<div>
			
				<EmailVerify heading={this.props.data.emailVerify.heading} paragraphText={this.props.data.emailVerify.textParagraph} />

			</div>
		)
	}
}

export default Verify;


// WEBPACK FOOTER //
// ./src/redux/components/templates/Verify.jsx